/* @generated from adl module ids.externalapi */

import * as ADL from './../runtime/adl';
import * as common from './../common';
import * as common_db from './../common/db';
import * as common_http from './../common/http';
import * as common_strings from './../common/strings';
import * as ids_common from './common';
import * as ids_db from './db';
import * as sys_types from './../sys/types';

export interface ExternalApiRequests {
  /**
   * Query hotels as per the provided query
   */
  queryHotels: common_http.HttpPost<HotelSearchQuery, HotelSearchResp>;
  /**
   * Returns a list of all available filtering options in a particular region
   */
  queryLocationInfo: common_http.HttpPost<LocationType, LocationInfoResp>;
  queryLocations: common_http.HttpPost<LocationSearchReq, LocationSearchResp>;
  /**
   * Returns supplier information for the supplier with the given ID
   */
  getSupplierById: common_http.HttpPost<GetSupplierConfigReq, GetSupplierConfigResp>;
  /**
   * Returns a list of known rooms for the hotel with the given ID
   */
  queryHotelRooms: common_http.HttpPost<QueryHotelRoomsReq, QueryHotelRoomsResp>;
  /**
   * Returns a list of nearby POIs for the hotel with the given ID
   */
  queryNearbyPoisToHotel: common_http.HttpPost<PoiNearHotelReq, PoiNearHotel[]>;
  /**
   * Returns a configurable number of hotel images based on the given hotel ID
   */
  queryHotelImages: common_http.HttpPost<HotelImageReq, HotelImageResp>;
}

export function makeExternalApiRequests(
  input: {
    queryHotels?: common_http.HttpPost<HotelSearchQuery, HotelSearchResp>,
    queryLocationInfo?: common_http.HttpPost<LocationType, LocationInfoResp>,
    queryLocations?: common_http.HttpPost<LocationSearchReq, LocationSearchResp>,
    getSupplierById?: common_http.HttpPost<GetSupplierConfigReq, GetSupplierConfigResp>,
    queryHotelRooms?: common_http.HttpPost<QueryHotelRoomsReq, QueryHotelRoomsResp>,
    queryNearbyPoisToHotel?: common_http.HttpPost<PoiNearHotelReq, PoiNearHotel[]>,
    queryHotelImages?: common_http.HttpPost<HotelImageReq, HotelImageResp>,
  }
): ExternalApiRequests {
  return {
    queryHotels: input.queryHotels === undefined ? {path : "/hotels/query", security : {kind : "tokenWithRole", value : "api"}, reqType : texprHotelSearchQuery(), respType : texprHotelSearchResp()} : input.queryHotels,
    queryLocationInfo: input.queryLocationInfo === undefined ? {path : "/location/info", security : {kind : "tokenWithRole", value : "api"}, reqType : texprLocationType(), respType : texprLocationInfoResp()} : input.queryLocationInfo,
    queryLocations: input.queryLocations === undefined ? {path : "/location/search", security : {kind : "tokenWithRole", value : "api"}, reqType : texprLocationSearchReq(), respType : texprLocationSearchResp()} : input.queryLocations,
    getSupplierById: input.getSupplierById === undefined ? {path : "/supplier", security : {kind : "tokenWithRole", value : "api"}, reqType : texprGetSupplierConfigReq(), respType : texprGetSupplierConfigResp()} : input.getSupplierById,
    queryHotelRooms: input.queryHotelRooms === undefined ? {path : "/hotels/rooms", security : {kind : "tokenWithRole", value : "api"}, reqType : texprQueryHotelRoomsReq(), respType : texprQueryHotelRoomsResp()} : input.queryHotelRooms,
    queryNearbyPoisToHotel: input.queryNearbyPoisToHotel === undefined ? {path : "/hotels/pois", security : {kind : "tokenWithRole", value : "api"}, reqType : texprPoiNearHotelReq(), respType : ADL.texprVector(texprPoiNearHotel())} : input.queryNearbyPoisToHotel,
    queryHotelImages: input.queryHotelImages === undefined ? {path : "/hotel/images", security : {kind : "tokenWithRole", value : "api"}, reqType : texprHotelImageReq(), respType : texprHotelImageResp()} : input.queryHotelImages,
  };
}

const ExternalApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query hotels as per the provided query\n"}],"serializedName":"queryHotels","default":{"kind":"just","value":{"path":"/hotels/query","security":{"tokenWithRole":"api"}}},"name":"queryHotels","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelSearchQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelSearchResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns a list of all available filtering options in a particular region\n"}],"serializedName":"queryLocationInfo","default":{"kind":"just","value":{"path":"/location/info","security":{"tokenWithRole":"api"}}},"name":"queryLocationInfo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationInfoResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"queryLocations","default":{"kind":"just","value":{"path":"/location/search","security":{"tokenWithRole":"api"}}},"name":"queryLocations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationSearchReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationSearchResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns supplier information for the supplier with the given ID\n"}],"serializedName":"getSupplierById","default":{"kind":"just","value":{"path":"/supplier","security":{"tokenWithRole":"api"}}},"name":"getSupplierById","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GetSupplierConfigReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GetSupplierConfigResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns a list of known rooms for the hotel with the given ID\n"}],"serializedName":"queryHotelRooms","default":{"kind":"just","value":{"path":"/hotels/rooms","security":{"tokenWithRole":"api"}}},"name":"queryHotelRooms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"QueryHotelRoomsReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"QueryHotelRoomsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns a list of nearby POIs for the hotel with the given ID\n"}],"serializedName":"queryNearbyPoisToHotel","default":{"kind":"just","value":{"path":"/hotels/pois","security":{"tokenWithRole":"api"}}},"name":"queryNearbyPoisToHotel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PoiNearHotelReq"}},"parameters":[]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PoiNearHotel"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns a configurable number of hotel images based on the given hotel ID\n"}],"serializedName":"queryHotelImages","default":{"kind":"just","value":{"path":"/hotel/images","security":{"tokenWithRole":"api"}}},"name":"queryHotelImages","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelImageReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelImageResp"}},"parameters":[]}]}}]}},"name":"ExternalApiRequests","version":{"kind":"nothing"}}};

export const snExternalApiRequests: ADL.ScopedName = {moduleName:"ids.externalapi", name:"ExternalApiRequests"};

export function texprExternalApiRequests(): ADL.ATypeExpr<ExternalApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snExternalApiRequests}, parameters : []}};
}

export interface PoiNearHotelReq {
  /**
   * The id of the hotel.
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * An optional POI category id to filter by, if present.
   */
  poiCategoryId: sys_types.Maybe<common_db.DbKey<ids_db.PoiCategory>>;
  /**
   * True to request only active POIs
   */
  isActiveOnly: boolean;
  /**
   * Max distance of POI away from hotel (metres). Default is 10km.
   */
  maxDistanceFromHotelMetres: number;
  /**
   * Max number of POIs to fetch. Default is 20.
   */
  maxPoisToFetch: number;
}

export function makePoiNearHotelReq(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    poiCategoryId: sys_types.Maybe<common_db.DbKey<ids_db.PoiCategory>>,
    isActiveOnly?: boolean,
    maxDistanceFromHotelMetres?: number,
    maxPoisToFetch?: number,
  }
): PoiNearHotelReq {
  return {
    hotelId: input.hotelId,
    poiCategoryId: input.poiCategoryId,
    isActiveOnly: input.isActiveOnly === undefined ? true : input.isActiveOnly,
    maxDistanceFromHotelMetres: input.maxDistanceFromHotelMetres === undefined ? 10000 : input.maxDistanceFromHotelMetres,
    maxPoisToFetch: input.maxPoisToFetch === undefined ? 20 : input.maxPoisToFetch,
  };
}

const PoiNearHotelReq_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The id of the hotel.\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An optional POI category id to filter by, if present.\n"}],"serializedName":"poiCategoryId","default":{"kind":"nothing"},"name":"poiCategoryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"PoiCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"True to request only active POIs\n"}],"serializedName":"isActiveOnly","default":{"kind":"just","value":true},"name":"isActiveOnly","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max distance of POI away from hotel (metres). Default is 10km.\n"}],"serializedName":"maxDistanceFromHotelMetres","default":{"kind":"just","value":10000},"name":"maxDistanceFromHotelMetres","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Max number of POIs to fetch. Default is 20.\n"}],"serializedName":"maxPoisToFetch","default":{"kind":"just","value":20},"name":"maxPoisToFetch","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"PoiNearHotelReq","version":{"kind":"nothing"}}};

export const snPoiNearHotelReq: ADL.ScopedName = {moduleName:"ids.externalapi", name:"PoiNearHotelReq"};

export function texprPoiNearHotelReq(): ADL.ATypeExpr<PoiNearHotelReq> {
  return {value : {typeRef : {kind: "reference", value : snPoiNearHotelReq}, parameters : []}};
}

export interface PoiNearHotel {
  /**
   * POI near hotel.
   */
  poi: common_db.WithDbId<ids_db.Poi>;
  /**
   * Distance of POI away from hotel (metres).
   */
  distanceFromHotel: number;
}

export function makePoiNearHotel(
  input: {
    poi: common_db.WithDbId<ids_db.Poi>,
    distanceFromHotel: number,
  }
): PoiNearHotel {
  return {
    poi: input.poi,
    distanceFromHotel: input.distanceFromHotel,
  };
}

const PoiNearHotel_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"POI near hotel.\n"}],"serializedName":"poi","default":{"kind":"nothing"},"name":"poi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Poi"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Distance of POI away from hotel (metres).\n"}],"serializedName":"distanceFromHotel","default":{"kind":"nothing"},"name":"distanceFromHotel","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"PoiNearHotel","version":{"kind":"nothing"}}};

export const snPoiNearHotel: ADL.ScopedName = {moduleName:"ids.externalapi", name:"PoiNearHotel"};

export function texprPoiNearHotel(): ADL.ATypeExpr<PoiNearHotel> {
  return {value : {typeRef : {kind: "reference", value : snPoiNearHotel}, parameters : []}};
}

export interface GetSupplierConfigReq {
  supplierId: common_db.DbKey<ids_db.Supplier>;
}

export function makeGetSupplierConfigReq(
  input: {
    supplierId: common_db.DbKey<ids_db.Supplier>,
  }
): GetSupplierConfigReq {
  return {
    supplierId: input.supplierId,
  };
}

const GetSupplierConfigReq_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"supplierId","default":{"kind":"nothing"},"name":"supplierId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Supplier"}},"parameters":[]}]}}]}},"name":"GetSupplierConfigReq","version":{"kind":"nothing"}}};

export const snGetSupplierConfigReq: ADL.ScopedName = {moduleName:"ids.externalapi", name:"GetSupplierConfigReq"};

export function texprGetSupplierConfigReq(): ADL.ATypeExpr<GetSupplierConfigReq> {
  return {value : {typeRef : {kind: "reference", value : snGetSupplierConfigReq}, parameters : []}};
}

export interface GetSupplierConfigResp {
  supplier: sys_types.Maybe<ids_db.Supplier>;
}

export function makeGetSupplierConfigResp(
  input: {
    supplier: sys_types.Maybe<ids_db.Supplier>,
  }
): GetSupplierConfigResp {
  return {
    supplier: input.supplier,
  };
}

const GetSupplierConfigResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"supplier","default":{"kind":"nothing"},"name":"supplier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Supplier"}},"parameters":[]}]}}]}},"name":"GetSupplierConfigResp","version":{"kind":"nothing"}}};

export const snGetSupplierConfigResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"GetSupplierConfigResp"};

export function texprGetSupplierConfigResp(): ADL.ATypeExpr<GetSupplierConfigResp> {
  return {value : {typeRef : {kind: "reference", value : snGetSupplierConfigResp}, parameters : []}};
}

export interface QueryHotelRoomsReq {
  hotelId: common_db.DbKey<ids_db.Hotel>;
}

export function makeQueryHotelRoomsReq(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
  }
): QueryHotelRoomsReq {
  return {
    hotelId: input.hotelId,
  };
}

const QueryHotelRoomsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}}]}},"name":"QueryHotelRoomsReq","version":{"kind":"nothing"}}};

export const snQueryHotelRoomsReq: ADL.ScopedName = {moduleName:"ids.externalapi", name:"QueryHotelRoomsReq"};

export function texprQueryHotelRoomsReq(): ADL.ATypeExpr<QueryHotelRoomsReq> {
  return {value : {typeRef : {kind: "reference", value : snQueryHotelRoomsReq}, parameters : []}};
}

export interface QueryHotelRoomsResp {
  rooms: HotelRoomListing[];
}

export function makeQueryHotelRoomsResp(
  input: {
    rooms: HotelRoomListing[],
  }
): QueryHotelRoomsResp {
  return {
    rooms: input.rooms,
  };
}

const QueryHotelRoomsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"rooms","default":{"kind":"nothing"},"name":"rooms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelRoomListing"}},"parameters":[]}]}}]}},"name":"QueryHotelRoomsResp","version":{"kind":"nothing"}}};

export const snQueryHotelRoomsResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"QueryHotelRoomsResp"};

export function texprQueryHotelRoomsResp(): ADL.ATypeExpr<QueryHotelRoomsResp> {
  return {value : {typeRef : {kind: "reference", value : snQueryHotelRoomsResp}, parameters : []}};
}

export interface HotelRoomListing {
  hotelRoom: common_db.WithDbId<ids_db.HotelRoom>;
  images: GalleryImage[];
}

export function makeHotelRoomListing(
  input: {
    hotelRoom: common_db.WithDbId<ids_db.HotelRoom>,
    images: GalleryImage[],
  }
): HotelRoomListing {
  return {
    hotelRoom: input.hotelRoom,
    images: input.images,
  };
}

const HotelRoomListing_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hotelRoom","default":{"kind":"nothing"},"name":"hotelRoom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelRoom"}},"parameters":[]}]}},{"annotations":[],"serializedName":"images","default":{"kind":"nothing"},"name":"images","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GalleryImage"}},"parameters":[]}]}}]}},"name":"HotelRoomListing","version":{"kind":"nothing"}}};

export const snHotelRoomListing: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelRoomListing"};

export function texprHotelRoomListing(): ADL.ATypeExpr<HotelRoomListing> {
  return {value : {typeRef : {kind: "reference", value : snHotelRoomListing}, parameters : []}};
}

/**
 * A query for hotel information based on a user search
 */
export interface HotelSearchQuery {
  /**
   * The location where we should perform the search
   */
  location: LocationType;
  /**
   * A wildcard search for a hotel name
   */
  hotelName: (common_strings.StringNE|null);
  /**
   * Filters by amenities available at the hotel (empty list signifies any amenities)
   */
  amenities: common_db.DbKey<ids_db.Amenity>[];
  /**
   * Filters by star ratings of the hotel (empty list signifies any stars)
   */
  starRatings: ids_common.StarRating[];
  /**
   * Filters by hotels in the given list of categories (empty list signifies no filtering)
   */
  hotelCategories: common_db.DbKey<ids_db.HotelCategory>[];
  /**
   * Filters hotels based on the provided sub-regions (empty list signifies no filtering)
   * Note that the regions provided here must be a sub region of regionId,
   * otherwise they will have no filtering effect
   */
  regions: common_db.DbKey<ids_db.Region>[];
  /**
   * Filters by hotels that are members of the given chains (empty list signifies no filtering)
   */
  hotelChains: common_db.DbKey<ids_db.HotelChain>[];
}

export function makeHotelSearchQuery(
  input: {
    location: LocationType,
    hotelName?: (common_strings.StringNE|null),
    amenities?: common_db.DbKey<ids_db.Amenity>[],
    starRatings?: ids_common.StarRating[],
    hotelCategories?: common_db.DbKey<ids_db.HotelCategory>[],
    regions?: common_db.DbKey<ids_db.Region>[],
    hotelChains?: common_db.DbKey<ids_db.HotelChain>[],
  }
): HotelSearchQuery {
  return {
    location: input.location,
    hotelName: input.hotelName === undefined ? null : input.hotelName,
    amenities: input.amenities === undefined ? [] : input.amenities,
    starRatings: input.starRatings === undefined ? [] : input.starRatings,
    hotelCategories: input.hotelCategories === undefined ? [] : input.hotelCategories,
    regions: input.regions === undefined ? [] : input.regions,
    hotelChains: input.hotelChains === undefined ? [] : input.hotelChains,
  };
}

const HotelSearchQuery_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A query for hotel information based on a user search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The location where we should perform the search\n"}],"serializedName":"location","default":{"kind":"nothing"},"name":"location","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A wildcard search for a hotel name\n"}],"serializedName":"hotelName","default":{"kind":"just","value":null},"name":"hotelName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by amenities available at the hotel (empty list signifies any amenities)\n"}],"serializedName":"amenities","default":{"kind":"just","value":[]},"name":"amenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by star ratings of the hotel (empty list signifies any stars)\n"}],"serializedName":"starRatings","default":{"kind":"just","value":[]},"name":"starRatings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by hotels in the given list of categories (empty list signifies no filtering)\n"}],"serializedName":"hotelCategories","default":{"kind":"just","value":[]},"name":"hotelCategories","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters hotels based on the provided sub-regions (empty list signifies no filtering)\nNote that the regions provided here must be a sub region of regionId,\notherwise they will have no filtering effect\n"}],"serializedName":"regions","default":{"kind":"just","value":[]},"name":"regions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by hotels that are members of the given chains (empty list signifies no filtering)\n"}],"serializedName":"hotelChains","default":{"kind":"just","value":[]},"name":"hotelChains","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}}]}},"name":"HotelSearchQuery","version":{"kind":"nothing"}}};

export const snHotelSearchQuery: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelSearchQuery"};

export function texprHotelSearchQuery(): ADL.ATypeExpr<HotelSearchQuery> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchQuery}, parameters : []}};
}

export interface LocationType_Region {
  kind: 'region';
  value: common_db.DbKey<ids_db.Region>;
}
export interface LocationType_Poi {
  kind: 'poi';
  value: common_db.DbKey<ids_db.Poi>;
}
export interface LocationType_Hotel {
  kind: 'hotel';
  value: common_db.DbKey<ids_db.Hotel>;
}
export interface LocationType_Bounds {
  kind: 'bounds';
  value: common.GeoPolygon;
}

/**
 * Defines the region to search
 */
export type LocationType = LocationType_Region | LocationType_Poi | LocationType_Hotel | LocationType_Bounds;

export interface LocationTypeOpts {
  /**
   * Return all hotels in a particular region
   */
  region: common_db.DbKey<ids_db.Region>;
  /**
   * Return all hotels associated with a particular point of interest
   */
  poi: common_db.DbKey<ids_db.Poi>;
  /**
   * Return all hotels associated with a particular hotel
   */
  hotel: common_db.DbKey<ids_db.Hotel>;
  /**
   * Return all hotels within the given bounds
   */
  bounds: common.GeoPolygon;
}

export function makeLocationType<K extends keyof LocationTypeOpts>(kind: K, value: LocationTypeOpts[K]) { return {kind, value}; }

const LocationType_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines the region to search\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Return all hotels in a particular region\n"}],"serializedName":"region","default":{"kind":"nothing"},"name":"region","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Return all hotels associated with a particular point of interest\n"}],"serializedName":"poi","default":{"kind":"nothing"},"name":"poi","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Poi"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Return all hotels associated with a particular hotel\n"}],"serializedName":"hotel","default":{"kind":"nothing"},"name":"hotel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Return all hotels within the given bounds\n"}],"serializedName":"bounds","default":{"kind":"nothing"},"name":"bounds","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"GeoPolygon"}},"parameters":[]}}]}},"name":"LocationType","version":{"kind":"nothing"}}};

export const snLocationType: ADL.ScopedName = {moduleName:"ids.externalapi", name:"LocationType"};

export function texprLocationType(): ADL.ATypeExpr<LocationType> {
  return {value : {typeRef : {kind: "reference", value : snLocationType}, parameters : []}};
}

/**
 * Response to a hotel search query
 */
export interface HotelSearchResp {
  /**
   * The hotels returned by the search query
   */
  hotels: HotelSearchResult[];
}

export function makeHotelSearchResp(
  input: {
    hotels: HotelSearchResult[],
  }
): HotelSearchResp {
  return {
    hotels: input.hotels,
  };
}

const HotelSearchResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Response to a hotel search query\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotels returned by the search query\n"}],"serializedName":"hotels","default":{"kind":"nothing"},"name":"hotels","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelSearchResult"}},"parameters":[]}]}}]}},"name":"HotelSearchResp","version":{"kind":"nothing"}}};

export const snHotelSearchResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelSearchResp"};

export function texprHotelSearchResp(): ADL.ATypeExpr<HotelSearchResp> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchResp}, parameters : []}};
}

/**
 * Search request for a given location with free text
 */
export interface LocationSearchReq {
  searchText: common_strings.StringNE;
}

export function makeLocationSearchReq(
  input: {
    searchText: common_strings.StringNE,
  }
): LocationSearchReq {
  return {
    searchText: input.searchText,
  };
}

const LocationSearchReq_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Search request for a given location with free text\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"searchText","default":{"kind":"nothing"},"name":"searchText","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"LocationSearchReq","version":{"kind":"nothing"}}};

export const snLocationSearchReq: ADL.ScopedName = {moduleName:"ids.externalapi", name:"LocationSearchReq"};

export function texprLocationSearchReq(): ADL.ATypeExpr<LocationSearchReq> {
  return {value : {typeRef : {kind: "reference", value : snLocationSearchReq}, parameters : []}};
}

/**
 * Locations that match a users free text search
 */
export interface LocationSearchResp {
  /**
   * Locations that match the search string
   */
  availableLocations: Location[];
  /**
   * Hotels that have names that match the search string
   */
  availableHotels: BasicHotelInfo[];
}

export function makeLocationSearchResp(
  input: {
    availableLocations: Location[],
    availableHotels: BasicHotelInfo[],
  }
): LocationSearchResp {
  return {
    availableLocations: input.availableLocations,
    availableHotels: input.availableHotels,
  };
}

const LocationSearchResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Locations that match a users free text search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Locations that match the search string\n"}],"serializedName":"availableLocations","default":{"kind":"nothing"},"name":"availableLocations","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"Location"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotels that have names that match the search string\n"}],"serializedName":"availableHotels","default":{"kind":"nothing"},"name":"availableHotels","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"BasicHotelInfo"}},"parameters":[]}]}}]}},"name":"LocationSearchResp","version":{"kind":"nothing"}}};

export const snLocationSearchResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"LocationSearchResp"};

export function texprLocationSearchResp(): ADL.ATypeExpr<LocationSearchResp> {
  return {value : {typeRef : {kind: "reference", value : snLocationSearchResp}, parameters : []}};
}

export interface BasicHotelInfo {
  /**
   * The name of the hotel
   */
  name: string;
  /**
   * The address of the hotel
   */
  address: ids_common.Address;
  /**
   * The ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
}

export function makeBasicHotelInfo(
  input: {
    name: string,
    address: ids_common.Address,
    hotelId: common_db.DbKey<ids_db.Hotel>,
  }
): BasicHotelInfo {
  return {
    name: input.name,
    address: input.address,
    hotelId: input.hotelId,
  };
}

const BasicHotelInfo_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the hotel\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The address of the hotel\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}}]}},"name":"BasicHotelInfo","version":{"kind":"nothing"}}};

export const snBasicHotelInfo: ADL.ScopedName = {moduleName:"ids.externalapi", name:"BasicHotelInfo"};

export function texprBasicHotelInfo(): ADL.ATypeExpr<BasicHotelInfo> {
  return {value : {typeRef : {kind: "reference", value : snBasicHotelInfo}, parameters : []}};
}

/**
 * A possible location returned from a location search
 */
export interface Location {
  locationType: LocationType;
  name: string;
  context: (string|null);
}

export function makeLocation(
  input: {
    locationType: LocationType,
    name: string,
    context: (string|null),
  }
): Location {
  return {
    locationType: input.locationType,
    name: input.name,
    context: input.context,
  };
}

const Location_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A possible location returned from a location search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"locationType","default":{"kind":"nothing"},"name":"locationType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"context","default":{"kind":"nothing"},"name":"context","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"Location","version":{"kind":"nothing"}}};

export const snLocation: ADL.ScopedName = {moduleName:"ids.externalapi", name:"Location"};

export function texprLocation(): ADL.ATypeExpr<Location> {
  return {value : {typeRef : {kind: "reference", value : snLocation}, parameters : []}};
}

/**
 * Information about available hotel filters in a given location
 */
export interface LocationInfoResp {
  /**
   * The bounding polygon of the region, will be null if the location
   * requested has no bounding polygon, for example if the POI requested has no
   * associated regions
   */
  region: (common.GeoPolygon|null);
  /**
   * Where a marker should be placed on the map. For a search of a region,
   * this marker would be at the centre of the region. For a search for a POI,
   * the marker would be placed at the POI
   */
  marker: common.LatLng;
  /**
   * All available amenities
   */
  amenities: common_db.WithDbId<ids_db.Amenity>[];
  /**
   * All available hotel categories
   */
  hotelCategories: common_db.WithDbId<ids_db.HotelCategory>[];
  /**
   * All available hotel chains
   */
  hotelChains: common_db.WithDbId<ids_db.HotelChain>[];
  /**
   * All available subregions
   */
  subRegions: common_db.WithDbId<ids_db.Region>[];
}

export function makeLocationInfoResp(
  input: {
    region: (common.GeoPolygon|null),
    marker: common.LatLng,
    amenities?: common_db.WithDbId<ids_db.Amenity>[],
    hotelCategories?: common_db.WithDbId<ids_db.HotelCategory>[],
    hotelChains?: common_db.WithDbId<ids_db.HotelChain>[],
    subRegions?: common_db.WithDbId<ids_db.Region>[],
  }
): LocationInfoResp {
  return {
    region: input.region,
    marker: input.marker,
    amenities: input.amenities === undefined ? [] : input.amenities,
    hotelCategories: input.hotelCategories === undefined ? [] : input.hotelCategories,
    hotelChains: input.hotelChains === undefined ? [] : input.hotelChains,
    subRegions: input.subRegions === undefined ? [] : input.subRegions,
  };
}

const LocationInfoResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about available hotel filters in a given location\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The bounding polygon of the region, will be null if the location\nrequested has no bounding polygon, for example if the POI requested has no\nassociated regions\n"}],"serializedName":"region","default":{"kind":"nothing"},"name":"region","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"GeoPolygon"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Where a marker should be placed on the map. For a search of a region,\nthis marker would be at the centre of the region. For a search for a POI,\nthe marker would be placed at the POI\n"}],"serializedName":"marker","default":{"kind":"nothing"},"name":"marker","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"All available amenities\n"}],"serializedName":"amenities","default":{"kind":"just","value":[]},"name":"amenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"All available hotel categories\n"}],"serializedName":"hotelCategories","default":{"kind":"just","value":[]},"name":"hotelCategories","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"All available hotel chains\n"}],"serializedName":"hotelChains","default":{"kind":"just","value":[]},"name":"hotelChains","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"All available subregions\n"}],"serializedName":"subRegions","default":{"kind":"just","value":[]},"name":"subRegions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}]}}]}},"name":"LocationInfoResp","version":{"kind":"nothing"}}};

export const snLocationInfoResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"LocationInfoResp"};

export function texprLocationInfoResp(): ADL.ATypeExpr<LocationInfoResp> {
  return {value : {typeRef : {kind: "reference", value : snLocationInfoResp}, parameters : []}};
}

export interface CountryRef {
  code: string;
  name: string;
}

export function makeCountryRef(
  input: {
    code: string,
    name: string,
  }
): CountryRef {
  return {
    code: input.code,
    name: input.name,
  };
}

const CountryRef_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CountryRef","version":{"kind":"nothing"}}};

export const snCountryRef: ADL.ScopedName = {moduleName:"ids.externalapi", name:"CountryRef"};

export function texprCountryRef(): ADL.ATypeExpr<CountryRef> {
  return {value : {typeRef : {kind: "reference", value : snCountryRef}, parameters : []}};
}

/**
 * Details of a hotel to be provided to the user as well as links to suppliers
 * that provide pricing information about the hotel
 */
export interface HotelSearchResult {
  /**
   * The IDS ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * The name of the hotel
   */
  name: string;
  /**
   * The address of the hotel
   */
  address: ids_common.Address;
  /**
   * Phone number of hotel, if present.
   */
  phoneNumber: (ids_common.PhoneNumber|null);
  /**
   * Fax number of the hotel, if present.
   */
  faxNum: (ids_common.PhoneNumber|null);
  /**
   * Email address of hotel, if present.
   */
  emailAddress: (common_strings.EmailAddress|null);
  /**
   * The star rating
   */
  starRating: ids_common.StarRating;
  /**
   * The hotel related country
   */
  countryRef: (CountryRef|null);
  /**
   * A curated description of the hotel property
   */
  description: (common_strings.StringNE|null);
  /**
   * Hotel point/coordinates
   */
  point: common.LatLng;
  /**
   * The ID of the hotel category to which the hotel belongs
   */
  hotelCategory: (common_db.DbKey<ids_db.HotelCategory>|null);
  /**
   * URLs to hotel images
   */
  galleryImages: GalleryImage[];
  /**
   * List of amenities this hotel has
   */
  amenities: common_db.DbKey<ids_db.Amenity>[];
  /**
   * Hotel chain this hotel belongs to, null if the hotel does not belong to a chain
   */
  hotelChain: (common_db.DbKey<ids_db.HotelChain>|null);
  /**
   * List of regions that this hotel is associated with
   */
  regions: common_db.DbKey<ids_db.Region>[];
  /**
   * List of suppliers that will provide room rates for this hotel
   */
  priceProviders: PriceProvider[];
  /**
   * The distance to the search location provided in metres
   */
  distanceToLocation: number;
  /**
   * The nearest airports to the hotel
   */
  nearestAirports: PoiNearHotel[];
  /**
   * The popularity score of the hotel
   */
  score: number;
}

export function makeHotelSearchResult(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    name: string,
    address: ids_common.Address,
    phoneNumber: (ids_common.PhoneNumber|null),
    faxNum: (ids_common.PhoneNumber|null),
    emailAddress: (common_strings.EmailAddress|null),
    starRating: ids_common.StarRating,
    countryRef: (CountryRef|null),
    description: (common_strings.StringNE|null),
    point: common.LatLng,
    hotelCategory: (common_db.DbKey<ids_db.HotelCategory>|null),
    galleryImages: GalleryImage[],
    amenities: common_db.DbKey<ids_db.Amenity>[],
    hotelChain: (common_db.DbKey<ids_db.HotelChain>|null),
    regions: common_db.DbKey<ids_db.Region>[],
    priceProviders: PriceProvider[],
    distanceToLocation: number,
    nearestAirports: PoiNearHotel[],
    score: number,
  }
): HotelSearchResult {
  return {
    hotelId: input.hotelId,
    name: input.name,
    address: input.address,
    phoneNumber: input.phoneNumber,
    faxNum: input.faxNum,
    emailAddress: input.emailAddress,
    starRating: input.starRating,
    countryRef: input.countryRef,
    description: input.description,
    point: input.point,
    hotelCategory: input.hotelCategory,
    galleryImages: input.galleryImages,
    amenities: input.amenities,
    hotelChain: input.hotelChain,
    regions: input.regions,
    priceProviders: input.priceProviders,
    distanceToLocation: input.distanceToLocation,
    nearestAirports: input.nearestAirports,
    score: input.score,
  };
}

const HotelSearchResult_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of a hotel to be provided to the user as well as links to suppliers\nthat provide pricing information about the hotel\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The IDS ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the hotel\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The address of the hotel\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Phone number of hotel, if present.\n"}],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fax number of the hotel, if present.\n"}],"serializedName":"faxNum","default":{"kind":"nothing"},"name":"faxNum","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address of hotel, if present.\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The star rating\n"}],"serializedName":"starRating","default":{"kind":"nothing"},"name":"starRating","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel related country\n"}],"serializedName":"countryRef","default":{"kind":"nothing"},"name":"countryRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"CountryRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A curated description of the hotel property\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel point/coordinates\n"}],"serializedName":"point","default":{"kind":"nothing"},"name":"point","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the hotel category to which the hotel belongs\n"}],"serializedName":"hotelCategory","default":{"kind":"nothing"},"name":"hotelCategory","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"URLs to hotel images\n"}],"serializedName":"galleryImages","default":{"kind":"nothing"},"name":"galleryImages","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GalleryImage"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"List of amenities this hotel has\n"}],"serializedName":"amenities","default":{"kind":"nothing"},"name":"amenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel chain this hotel belongs to, null if the hotel does not belong to a chain\n"}],"serializedName":"hotelChain","default":{"kind":"nothing"},"name":"hotelChain","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"List of regions that this hotel is associated with\n"}],"serializedName":"regions","default":{"kind":"nothing"},"name":"regions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"List of suppliers that will provide room rates for this hotel\n"}],"serializedName":"priceProviders","default":{"kind":"nothing"},"name":"priceProviders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PriceProvider"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The distance to the search location provided in metres\n"}],"serializedName":"distanceToLocation","default":{"kind":"nothing"},"name":"distanceToLocation","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The nearest airports to the hotel\n"}],"serializedName":"nearestAirports","default":{"kind":"nothing"},"name":"nearestAirports","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PoiNearHotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The popularity score of the hotel\n"}],"serializedName":"score","default":{"kind":"nothing"},"name":"score","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"HotelSearchResult","version":{"kind":"nothing"}}};

export const snHotelSearchResult: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelSearchResult"};

export function texprHotelSearchResult(): ADL.ATypeExpr<HotelSearchResult> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchResult}, parameters : []}};
}

/**
 * Defines search parameters for hotel image search
 */
export interface HotelImageReq {
  /**
   * The internal ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * Number of images to return or null for all available images
   */
  count: (number|null);
}

export function makeHotelImageReq(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    count: (number|null),
  }
): HotelImageReq {
  return {
    hotelId: input.hotelId,
    count: input.count,
  };
}

const HotelImageReq_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines search parameters for hotel image search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The internal ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Number of images to return or null for all available images\n"}],"serializedName":"count","default":{"kind":"nothing"},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}}]}},"name":"HotelImageReq","version":{"kind":"nothing"}}};

export const snHotelImageReq: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelImageReq"};

export function texprHotelImageReq(): ADL.ATypeExpr<HotelImageReq> {
  return {value : {typeRef : {kind: "reference", value : snHotelImageReq}, parameters : []}};
}

export interface HotelImageResp {
  /**
   * URLs to hotel images
   */
  galleryImages: GalleryImage[];
}

export function makeHotelImageResp(
  input: {
    galleryImages: GalleryImage[],
  }
): HotelImageResp {
  return {
    galleryImages: input.galleryImages,
  };
}

const HotelImageResp_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"URLs to hotel images\n"}],"serializedName":"galleryImages","default":{"kind":"nothing"},"name":"galleryImages","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GalleryImage"}},"parameters":[]}]}}]}},"name":"HotelImageResp","version":{"kind":"nothing"}}};

export const snHotelImageResp: ADL.ScopedName = {moduleName:"ids.externalapi", name:"HotelImageResp"};

export function texprHotelImageResp(): ADL.ATypeExpr<HotelImageResp> {
  return {value : {typeRef : {kind: "reference", value : snHotelImageResp}, parameters : []}};
}

/**
 * An image to display in a image gallery
 */
export interface GalleryImage {
  /**
   * The URL of the image
   */
  url: string;
  /**
   * True if the image should be the hero image
   */
  isHeroImage: boolean;
  /**
   * The caption of the image
   */
  caption: (string|null);
}

export function makeGalleryImage(
  input: {
    url: string,
    isHeroImage: boolean,
    caption: (string|null),
  }
): GalleryImage {
  return {
    url: input.url,
    isHeroImage: input.isHeroImage,
    caption: input.caption,
  };
}

const GalleryImage_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An image to display in a image gallery\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The URL of the image\n"}],"serializedName":"url","default":{"kind":"nothing"},"name":"url","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"True if the image should be the hero image\n"}],"serializedName":"isHeroImage","default":{"kind":"nothing"},"name":"isHeroImage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The caption of the image\n"}],"serializedName":"caption","default":{"kind":"nothing"},"name":"caption","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"GalleryImage","version":{"kind":"nothing"}}};

export const snGalleryImage: ADL.ScopedName = {moduleName:"ids.externalapi", name:"GalleryImage"};

export function texprGalleryImage(): ADL.ATypeExpr<GalleryImage> {
  return {value : {typeRef : {kind: "reference", value : snGalleryImage}, parameters : []}};
}

/**
 * Details of a supplier that can provide room rates for this hotel
 */
export interface PriceProvider {
  /**
   * The ID of a supplier, e.g. Expedia in our DB
   */
  supplierId: common_db.DbKey<ids_db.Supplier>;
  /**
   * The ID of the hotel within that supplier
   */
  supplierHotelId: string;
}

export function makePriceProvider(
  input: {
    supplierId: common_db.DbKey<ids_db.Supplier>,
    supplierHotelId: string,
  }
): PriceProvider {
  return {
    supplierId: input.supplierId,
    supplierHotelId: input.supplierHotelId,
  };
}

const PriceProvider_AST : ADL.ScopedDecl =
  {"moduleName":"ids.externalapi","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of a supplier that can provide room rates for this hotel\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of a supplier, e.g. Expedia in our DB\n"}],"serializedName":"supplierId","default":{"kind":"nothing"},"name":"supplierId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Supplier"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the hotel within that supplier\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PriceProvider","version":{"kind":"nothing"}}};

export const snPriceProvider: ADL.ScopedName = {moduleName:"ids.externalapi", name:"PriceProvider"};

export function texprPriceProvider(): ADL.ATypeExpr<PriceProvider> {
  return {value : {typeRef : {kind: "reference", value : snPriceProvider}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ids.externalapi.ExternalApiRequests" : ExternalApiRequests_AST,
  "ids.externalapi.PoiNearHotelReq" : PoiNearHotelReq_AST,
  "ids.externalapi.PoiNearHotel" : PoiNearHotel_AST,
  "ids.externalapi.GetSupplierConfigReq" : GetSupplierConfigReq_AST,
  "ids.externalapi.GetSupplierConfigResp" : GetSupplierConfigResp_AST,
  "ids.externalapi.QueryHotelRoomsReq" : QueryHotelRoomsReq_AST,
  "ids.externalapi.QueryHotelRoomsResp" : QueryHotelRoomsResp_AST,
  "ids.externalapi.HotelRoomListing" : HotelRoomListing_AST,
  "ids.externalapi.HotelSearchQuery" : HotelSearchQuery_AST,
  "ids.externalapi.LocationType" : LocationType_AST,
  "ids.externalapi.HotelSearchResp" : HotelSearchResp_AST,
  "ids.externalapi.LocationSearchReq" : LocationSearchReq_AST,
  "ids.externalapi.LocationSearchResp" : LocationSearchResp_AST,
  "ids.externalapi.BasicHotelInfo" : BasicHotelInfo_AST,
  "ids.externalapi.Location" : Location_AST,
  "ids.externalapi.LocationInfoResp" : LocationInfoResp_AST,
  "ids.externalapi.CountryRef" : CountryRef_AST,
  "ids.externalapi.HotelSearchResult" : HotelSearchResult_AST,
  "ids.externalapi.HotelImageReq" : HotelImageReq_AST,
  "ids.externalapi.HotelImageResp" : HotelImageResp_AST,
  "ids.externalapi.GalleryImage" : GalleryImage_AST,
  "ids.externalapi.PriceProvider" : PriceProvider_AST
};
